var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSlidesBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 778,
    height: 116,
    viewBox: "0 0 778 116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_200_14)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.5 -29.5H778.5V6C778.5 6 735.5 -12 700 33C661.591 81.687 629 99 586.5 96C544 93 495.573 40.5655 434.5 33C339.8 21.2688 299.812 120.129 204.5 115.5C145.077 112.614 117.678 65.8782 58.5 72C34.8037 74.451 -0.5 87.5 -0.5 87.5V-29.5Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_200_14"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 778,
    height: 116,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlidesBg);
export default __webpack_public_path__ + "static/media/slides-bg.2a7591645fc9b7bc61aeb65b41be7332.svg";
export { ForwardRef as ReactComponent };